import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "../../axios";
import Search from "../search/Search";
import ReactPaginate from "react-paginate";
import Loader from "../loader/Loader";
import { toast } from "react-toastify";

const SafetyOfChildren = () => {
  const [privacypolicy, setprivacypolicy] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  // pagination
  const [pageNumber, setPageNumber] = useState(0);
  const productsPerPage = 8;
  const pagesVisited = pageNumber * productsPerPage;
  let displayprivacypolicy = [];
  const pageCount = Math.ceil(filtered.length / productsPerPage);

  const changePage = ({ selected }) => {
    setPageNumber(selected);
  };

  useEffect(() => {
    axios
      .get("safety-of-children/all")
      .then((res) => {
        setprivacypolicy(res?.data);
        setFiltered(res?.data);
        setIsLoading(false);
      })
      .catch((err) => {
        toast.error("Something went wrong!");
        console.log(err);
      });
  }, []);

  return (
    <div className="privacy_policy p-5 text-left">
      <div className="page-title">
        <h1>Safety of Children</h1>
      </div>
      <div className="row px-0 search">
        <div className="col-md-9">
          <Search
            data={privacypolicy}
            title="SafetyOfChildren"
            filtered={setFiltered}
            setPageNumber={setPageNumber}
          />
        </div>

        <div className="col-md-3">
          <Link to="/safety-of-children/add" className="myButton">
            Add New
          </Link>
        </div>
      </div>

      <div className="listimi-tabela">
        {isLoading ? (
          <Loader />
        ) : (
          <>
            <div className="listimi-head">
              <div className="row">
                <div className="col-2">Content Al</div>
                <div className="col-2">Content En</div>
                <div className="col-2">Content Sr</div>
                <div className="col-1">ALB</div>
                <div className="col-1">SRB</div>
                <div className="col-1">ENG</div>
                <div className="col-1 hideme"> </div>
              </div>
            </div>
            {
              (displayprivacypolicy = filtered
                ?.slice(pagesVisited, pagesVisited + productsPerPage)
                ?.map((filtered) => {
                  return (
                    <div className="listimi showme" key={filtered.id}>
                      <div className="row">
                        <div className="col-2">
                          <h6>{filtered?.content_al.slice(0, 25) + "..."}</h6>
                        </div>
                        <div className="col-2">
                          <h6>{filtered?.content_en.slice(0, 25) + "..."}</h6>
                        </div>
                        <div className="col-2">
                          <h6>{filtered?.content_sr.slice(0, 25) + "..."}</h6>
                        </div>

                        <div className="col-1">
                          {filtered.content_al === null ||
                          filtered.content_al === "" ? (
                            <i className="far fa-times-circle text-danger"></i>
                          ) : (
                            <i className="far fa-check-circle text-success"></i>
                          )}
                        </div>

                        <div className="col-1">
                          {filtered.content_sr === null ||
                          filtered.content_sr === "" ? (
                            <i className="far fa-times-circle text-danger"></i>
                          ) : (
                            <i className="far fa-check-circle text-success"></i>
                          )}
                        </div>

                        <div className="col-1">
                          {filtered.content_en === null ||
                          filtered.content_en === "" ? (
                            <i className="far fa-times-circle text-danger"></i>
                          ) : (
                            <i className="far fa-check-circle text-success"></i>
                          )}
                        </div>

                        <div className="col-1 delete">
                          <Link
                            className={"fa fa-trash"}
                            to={"/safety-of-children/delete/" + filtered.id}
                          ></Link>
                        </div>

                        <div className="col-1 edit">
                          <Link
                            className={"fa fa-edit"}
                            to={"/safety-of-children/edit/" + filtered.id}
                          ></Link>
                        </div>
                      </div>
                    </div>
                  );
                }))
            }
          </>
        )}
      </div>
      <div className="row mt-5">
        <div className="col-12">
          {privacypolicy.length >= productsPerPage ? (
            <ReactPaginate
              previousLabel={"Previous"}
              nextLabel={"Next"}
              pageCount={pageCount}
              onPageChange={changePage}
              containerClassName={"paginationBttns"}
              previousLinkClassName={"previousBttn"}
              nextLinkClassName={"nextBttn"}
              disabledClassName={"paginationDisabled"}
              activeClassName={"paginationActive"}
            />
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
};

export default SafetyOfChildren;
